import { queryClient } from '@/common/lib/queryClient';
import {
  getGetV7DatasStatQueryKey,
  getGetV7DatasStatQueryOptions,
} from '@/api-client/metav6/queries/data-stat-information-controller/data-stat-information-controller';
import { getGetV8DashboardsWidgetsCustomImagesQueryKey } from '@/api-client/metav8Over/queries/widget-custom-image-controller/widget-custom-image-controller';
import { getGetV7MenuPathQueryKey } from '@/api-client/dashboard/queries/integrated-dashboard-gnb-v7-controller/integrated-dashboard-gnb-v7-controller';
import { useMyInfoStore } from '@/config/stores/my-info';

export const fetchStatData = async () => {
  const { userId } = useMyInfoStore().myInfo;

  await queryClient.fetchQuery(
    getGetV7DatasStatQueryOptions({
      userId: userId ?? -1,
    }),
  );
};

export const invalidateStatData = () => {
  const { userId } = useMyInfoStore().myInfo;

  queryClient.invalidateQueries({
    queryKey: getGetV7DatasStatQueryKey({ userId: userId ?? -1 }),
  });
};

export const invalidateDashboardImages = () => {
  queryClient.invalidateQueries({
    queryKey: getGetV8DashboardsWidgetsCustomImagesQueryKey(),
  });
};

export const invalidatePlatformDashboardMenuPath = () => {
  queryClient.invalidateQueries({
    queryKey: getGetV7MenuPathQueryKey(),
  });
};
